import { planningAPI } from "../../axios";

export const actions = {

    // StaffingPattern
    GetAllStaffingPattern(context, data){
        return planningAPI.get(`StaffingPattern/All/${data.campusId}`);
    },
    UpdateStaffingPattern(context, data){
        return planningAPI.put(`StaffingPattern/Update`, data);
    },
    DeleteStaffingPattern(context, data){
        return planningAPI.delete(`StaffingPattern/Remove/${data}`);
    },
    CreateStaffingPattern(context, data){
        return planningAPI.post(`StaffingPattern/Add?cycle=${data.cycle}&campusId=${data.campusId}`, data.data);
    },

}